export enum ModalType {
  Form = "Form",
  Chart = "Chart",
  Url = "Url",
  Vimeo = "Vimeo",
  ShareCell = "ShareCell",
}